/**
 * Channel test page:
 * https://localhost/test/app/neuplayer_channel.html
 *
 * Program test page:
 * https://localhost/test/app/neuplayer_video.html
 *
 * Common Dependency:
 * 1. <script type="text/javascript" src="${requestScope.locResource}base/site/scripts/nlplayer2.js"></script>
 * 2. <script type="text/javascript" src="${requestScope.locResource}${requestScope.siteId}/app/site/scripts/neu.min.js"></script>
 * 3. <script type="text/javascript" src="${requestScope.locResource}${requestScope.siteId}/app/site/scripts/modal.min.js"></script>
 * 4. <link rel="stylesheet" type="text/css" href="${requestScope.locResource}${requestScope.siteId}/app/site/styles/modal.css" />
 * 5. <link rel="stylesheet" type="text/css" href="${requestScope.locResource}${requestScope.siteId}/app/site/styles/modal-theme.css" />
 * 6. <jsp:include page="_variable.jsp" />
 *
 * Common Optional:
 * 1. var nlCustomPlayerConfig = {
				containerId: 'videoContainer',                              // default: nlPlayerContainer
				brand: SITE_ID,                                             // Hide Default logo
				customScripts: [
					LOC_RESOURCE + "site_4/player/scripts/nlcontrols.js",     // custom player control bar script file
					LOC_RESOURCE + "site_4/player/scripts/nlplayerstrings.js" // custom player localization file
				],
				customStyles: [
					LOC_RESOURCE + "site_4/player/styles/nlcontrols.css"      // custom player control bar style file
				],
			};
 *
 * Game Optional:
 * 1. gamePlayer, will be used when page import (nl)gameplayer.js; if not, will call nlPlayVideo(video);
 *
 * Channel Dependency:
 * 1. nlcplayer.js
 * 2. var g_channel = {
				id: "${requestScope.channel.id}",
				name: "${requestScope.channel.name}",
				seoName: "${requestScope.channel.seo_name}",
				image: "${requestScope.locResource}${siteId}/..........",
				isLive: true,
				type: "channel",
				noAccess: ${requestScope.channel.noAccess == true}, // ** Required by EPGList
				date: "<fmt:formatDate value="${requestScope.currentDate}" pattern="yyyy-MM-dd'T'HH:mm:ss.SSS" timeZone="${requestScope.channel.time_zone}" />"
				// drm: true
			};
 *
 * Channel Optional: (Should all have when has EPGList component)
 * 1. epgList.js
 * 2. window.epgList = new EPGList($('#epgContainer'), epgOption);
 *
 */

import Event from "./Event";
import I18N from "./I18N";
import NeuPlayerStrings from "./neuplayerstrings";
import {addClass, removeClass} from "./ClassName";

class Markers {
	TYPES = {
		intro: true,
		chapter: true,
		scene: true,
		ad: true,
		credits: true,
		annotation: true
	};
	CLASS_NAMES = {
		container: 'marker-container',
		item: 'marker-item',
		show: 'marker-show',
	};

	constructor(neuPlayer, option) {
		this.player = neuPlayer;
		this._option = option;

		// config
		this.playerContainer = document.getElementById(neuPlayer.playerInitConfig.containerId);

		// option
		this.containerClass = option.containerClass || this.CLASS_NAMES.container;
		this.itemClass = option.itemClass || this.CLASS_NAMES.item;
		this.showClass = option.showClass || this.CLASS_NAMES.show;
		this.supportTypes = option.supportTypes || this.TYPES;

		// init
		this.containers = {};
		this.data = [];
		this.init = this.init.bind(this);
		this._destroy = this._destroy.bind(this);
		this._updateMarkerState = this._updateMarkerState.bind(this);
		this._handleMarkerClick = this._handleMarkerClick.bind(this);

		this.player.on(this.player.eventType.CALLBACK_MARKERS, this.init);
	}

	init(markers) {
		this._initElements(markers);
		this._initEventListeners();
		this._option.readyCallback && this._option.readyCallback(this);
	}

	destroy() {
		this.player.off(this.player.eventType.CALLBACK_MARKERS, this.init);
		this._destroy();
	}

	_destroy() {
		// destroy event
		this._destroyEventListeners();

		// Clean data
		this.data = [];

		// destroy dom
		[].forEach.call(Object.values(this.containers), markerContainer => {
			if (markerContainer) {
				let containerTypeIndex = markerContainer.querySelector(`.${this.CLASS_NAMES.item}`).getAttribute('data-id');
				delete this.containers[containerTypeIndex];
				markerContainer.parentNode.removeChild(markerContainer);
			}
		});
	}

	_initElements(markers) {
		if (Object.keys(this.containers).length) {
			this._destroy();
		}

		this.data = [...markers];

		markers.forEach((marker, index) => {
			let id = Markers._setIdWithTypeAndIndex(marker.type, index);
			this.data[index].id = id;

			if (this.supportTypes[marker.type]) {
				let getElementDom = this._option.getElementDom,
						markerElement = null;
				if (getElementDom) {
					markerElement = getElementDom(marker);
					if (markerElement) {
						// Add dom data class and attributes
						addClass(markerElement, id);
						addClass(markerElement, marker.type);

						let markerItem = markerElement.querySelector(`.${this.itemClass}`);
						if (markerItem) {
							markerItem.setAttribute('data-type', marker.type);
							markerItem.setAttribute('data-id', id);
							markerItem.setAttribute('data-name', marker.name);
							markerItem.setAttribute('data-start', marker.start);
							markerItem.setAttribute('data-end', marker.end);
						} else {
							throw new Error(`Could not find marker item with class: ${this.itemClass}`);
						}
					}
				} else {
					markerElement = document.createElement('div');
					markerElement.setAttribute('class', `${this.containerClass} ${id} ${marker.type}`);
					markerElement.innerHTML = `<div class="${this.itemClass}" data-type="${marker.type}" data-id="${id}" data-name="${marker.name}" data-start="${marker.start}" data-end="${marker.end}">${marker.name}</div>`;
				}

				if (markerElement && markerElement.nodeType) {
					this.playerContainer.appendChild(markerElement);
					this.containers[id] = this.playerContainer.querySelector(`.${this.containerClass}.${id}`);
				}
			} else {
				// Not support types
			}
		});
	}

	_initEventListeners() {
		if (Object.keys(this.containers).length) {
			let {PLAYER_TIME_UPDATE, PLAYER_COMPLETED, PLAY_NEXT, STOP_PLAYER} = this.player.eventType;
			this.player.on(PLAYER_TIME_UPDATE, this._updateMarkerState);
			this.player.on(PLAYER_COMPLETED, this._destroy);
			this.player.on(STOP_PLAYER, this._destroy);
			this.player.on(PLAY_NEXT, this._destroy);
			this.playerContainer.addEventListener('click', this._handleMarkerClick);
		}
	}


	_destroyEventListeners() {
		if (Object.keys(this.containers).length) {
			let {PLAYER_TIME_UPDATE, PLAYER_COMPLETED, PLAY_NEXT} = this.player.eventType;
			this.player.off(PLAYER_TIME_UPDATE, this._updateMarkerState);
			this.player.off(PLAYER_COMPLETED, this._destroy);
			this.player.off(PLAY_NEXT, this._destroy);
			this.playerContainer.removeEventListener('click', this._handleMarkerClick);
		}
	}

	_updateMarkerState(currentTime) {
		let markers = this.playerContainer.querySelectorAll(`.${this.itemClass}`);
		[].forEach.call(markers, (marker) => {
			let startTime = marker.getAttribute('data-start') * 1,
					endTime = marker.getAttribute('data-end') * 1,
					id = `${marker.getAttribute('data-id')}`;
			if (currentTime < startTime || currentTime > endTime) {
				this._hideMarker(id);
			} else {
				this._showMarker(id);
			}
		});
	}

	_showMarker(id) {
		let markerElement = this.containers[id],
				getCustomShowCondition = this._option.getCustomShowCondition;
		if (markerElement && (!getCustomShowCondition || getCustomShowCondition(this.data[Markers._getIndexWithId(id)], this.player))) {
			addClass(markerElement, this.showClass);
		}
	}

	_hideMarker(id) {
		if (id) {
			let markerElement = this.containers[id],
					getCustomHideCondition = this._option.getCustomHideCondition;
			if (markerElement && (!getCustomHideCondition || getCustomHideCondition(this.data[Markers._getIndexWithId(id)], this.player))) {
				removeClass(markerElement, this.showClass);
			}
		} else {
			Object.keys(this.containers).forEach((id) => {
				this._hideMarker(id);
			})
		}
	}

	_handleMarkerClick(event) {
		if (event.target && event.target.matches(`.${this.itemClass}`)) {
			let id = event.target.getAttribute('data-id'),
					index = Markers._getIndexWithId(id);
			this._option.handleClick && this._option.handleClick(this.data[index]);
			this._hideMarker(id);
		}
	}

	// Static
	static _setIdWithTypeAndIndex(type, index) {
		return `${type}-${index}`;
	}

	static _getIndexWithId(id) {
		return id.split('-')[1] * 1;
	}
}

/**!
 * neuplayer.js v2.4.11.20191218
 */
class NeuPlayer extends Event {
	_video;
	_drmPlayer = null;
	_pluginClasses = {
		markers: Markers
	};
	pluginsInstances = {};
	TYPES = {
		event: 'event',
		program: 'program',
		channel: 'channel',
		game: 'game',
	};
	type;
	option = {};
	parentalControls = null;
	hasNEUEvent = false;
	eventType = {
		// States
		PLAY_START: 'PLAY_START', // Normal program's play start, not pre-roll ad's play start
		PLAYER_READY: 'PLAYER_READY',
		PLAYER_INIT_FAILED: 'PLAYER_INIT_FAILED',
		PLAYER_INITIALIZING: 'PLAYER_INITIALIZING',
		PLAYER_DESTROYED: 'PLAYER_DESTROYED',
		PLAYER_COMPLETED: 'PLAYER_COMPLETED',
		PLAYER_TIME_UPDATE: 'PLAYER_TIME_UPDATE',
		PLAYER_STATUS_UPDATE: 'PLAYER_STATUS_UPDATE',
		PLAYER_OCCURRED_ERROR: 'PLAYER_OCCURRED_ERROR',
		PLAYER_UNSUPPORTED: 'PLAYER_UNSUPPORTED',

		// Actions
		STOP_PLAYER: 'STOP_PLAYER',
		PAUSE_PLAYER: 'PAUSE_PLAYER',
		RESUME_PLAYER: 'RESUME_PLAYER',
		HIDE_PLAYER: 'HIDE_PLAYER',
		SEEK_PLAYER: 'SEEK_PLAYER',

		PLAY_NEXT: 'PLAY_NEXT',

		// Deprecation: Channel Status, use 'PLAY_CHANGED' instead
		PLAY_CHANNEL_LIVE_CONTINUE: 'PLAY_CHANNEL_LIVE_CONTINUE',
		PLAY_CHANNEL_CHANGED: 'PLAY_CHANNEL_CHANGED', // Contains: playChannel and playChannelLiveChanged

		PLAY_CHANGED: 'PLAY_CHANGED',

		// DRMPlayer
		DRM_PLAYER_PLAY_START: 'DRM_PLAYER_PLAY_START',
		DRM_PLAYER_ID3EVENT: 'DRM_PLAYER_ID3EVENT',
		DRM_PLAYER_TIME_UPDATE: 'DRM_PLAYER_TIME_UPDATE',

		// Marker events
		START_MARKER: 'START_MARKER',
		END_MARKER: 'END_MARKER',
		CLEAR_MARKERS: 'CLEAR_MARKERS',
		CALLBACK_MARKERS: 'CALLBACK_MARKERS',
	};
	GAME_TYPE = {
		BROADCAST: 1,
		HOME: 2,
		AWAY: 4,
		CONDENSED: 8,
		CONDENSED_HOME: 16,
		CONDENSED_AWAY: 32,
		FULL_HIGHLIGHT: 64,
		HALF_HIGHLIGHT: 128,
		AUDIO: 256,
		AUDIO_HOME: 512,
		AUDIO_AWAY: 1024
	};
	GAME_STATE = {
		NOT_AVAILABLE: -1,
		UPCOMING: 0,
		LIVE: 1,
		ARCHIVE_DVR: 2,
		ARCHIVE: 3,
		PENDING_ARCHIVE: 4,
	};

	constructor() {
		super();

		this._initControllerConfig();

		this._initPlayerEvents();
	}

	play(video, customConfig = {}, option = {}, type = 'program') {
		if (!this.SITE_CONFIG)
		{
			this._initConfig();
		}
		this._initPlayOptions(video, customConfig, option, type);

		this.video = this._preProcessVideo(video, option);

		if (!this.playerInitConfig || !this.controllerConfig.isPlayerReady) {
			this._initPlayerConfig();
			this._initPlugins();
		}

		this.video = this._postProcessVideo(this.video, option);

		if (this.controllerConfig.isInitFailed) {
			this._destroyNLPlayer();
			this.controllerConfig.isAdBlockedModalShown = false;
			this.controllerConfig.isAdBlockedModalShownFixed = false;
		}
		this.controllerConfig.isHidden = false;

		this._playVideoWhenPlayerIsReady();

		return this;
	}

	pause() {
		// Default pause function
		if (this.controllerConfig.isPlayerReady)
		{
			if (this.type === this.TYPES.game && !!this.gamePlayer) {
				this.gamePlayer.stop();
			}
			else {
				nlPauseVideo();
			}
		}
		this.trigger(this.eventType.PAUSE_PLAYER);
		return this;
	}

	resume() {
		// Default resume function
		if (this.controllerConfig.isPlayerReady) {
			if (this.type === this.TYPES.game && !!this.gamePlayer) {
				this.gamePlayer.resume();
			} else {
				nlResumeVideo();
			}
		}
		this.trigger(this.eventType.RESUME_PLAYER);
		return this;
	}

	stop() {
		// Stop adplayer
		!!nlAdPlayerObj && nlAdPlayerObj.stop();

		// Stop nlplayer
		if (!!nlLastProgram && this.controllerConfig.isPlayerReady && this.controllerConfig.isPlayStarted) {
			if (this.type === this.TYPES.game && !!this.gamePlayer)
			{
				this.gamePlayer.stop();
			}
			else if (this.type === this.TYPES.channel && !!this.channelPlayer)
			{
				this.channelPlayer.stopVOD();
			}
			else
			{
				window.nlStopVideo(!!this.playerInitConfig.hasAds);
			}
		}
		this.trigger(this.eventType.STOP_PLAYER);

		return this;
	}

	hide() {
		this.controllerConfig.isHidden = true;
		this.trigger(this.eventType.HIDE_PLAYER);
	}

	seek(time) {
		if (nlSeekVideo) {
			nlSeekVideo(time);
		}
		this.trigger(this.eventType.SEEK_PLAYER);
	}

	destroy() {
		super.destroy();

		this._destroyEvents();
		this._destroyNLPlayer();
	}

	_playWithParentControl(video, option = {}, successCallback) {
		const successHandler = (data) => {
			// Update final processed tvRating after parental check
			video.tvRating = !!data && data.tvRating || this.video.tvRating;

			// Play or Resume player
			if (!successCallback) {
				this._playerPlayWithPersonalData();
			} else {
				successCallback(video);
			}

			option.parentalControls && option.parentalControls.successHandler && option.parentalControls.successHandler(data);
		};
		const cancelHandler = (data) => {
			// Stop player
			this.stop();

			option.parentalControls && option.parentalControls.cancelHandler && option.parentalControls.cancelHandler(data);
		};
		const noAccessHandler = (data) => {
			// Pause player
			this.pause();
		};

		// Check Parental Controls
		if (!!window.ParentalControls) {
			this.parentalControls = this.parentalControls || new ParentalControls();
			this.parentalControls.check(video.tvRating, successHandler, cancelHandler, noAccessHandler);
		} else {
			console.warn(`[neuplayer]: parentalControls is undefined!`);
		}
	}

	_initControllerConfig() {
		this.controllerConfig = {
			isInitFailed: false,
			isHidden: false,
			isPlayStarted: false,
			isPlayerReady: undefined,
			tryPlayTimes: 600,
			tryPlayTimer: null,
			tryPlayTimeout: 100,
			isAdBlockedModalShown: true,
			isAdBlockedModalShownFixed: false,
			adBlockedTimer: null,
			adBlockedTimeout: 1000,
		};
	}

	_playVideoWhenPlayerIsReady() {
		if (this.controllerConfig.isPlayerReady === undefined) {
			this.trigger(this.eventType.PLAYER_INITIALIZING);

			this.controllerConfig.isPlayerReady = false;

			// Init player and play video
			this._initPlayer();

			// Hot fix
			this._fixedAdBlockErrorNotWork();
		} else if (this.controllerConfig.isPlayerReady === true) {
			this._playerPlay();
		} else {
			if (--this.controllerConfig.tryPlayTimes) {
				this.controllerConfig.tryPlayTimer = setTimeout(() => {
					this._playVideoWhenPlayerIsReady();
				}, this.controllerConfig.tryPlayTimeout);
			} else {
				this.controllerConfig.isInitFailed = true;
			}
		}
	}

	_initConfig() {
		this.SITE_CONFIG = NeuPlayer.getSiteConfig();
		this.PROJECT_CONFIG = NeuPlayer.getProjectConfig();
		this.CLIENT_CONFIG = NeuPlayer.getClientConfig();

		this.name = 'neuplayer';
		this.locale = (this.CLIENT_CONFIG.user && this.CLIENT_CONFIG.user.locale) || this.CLIENT_CONFIG.locale;
	}

	_initPlayer() {
		if (window.GamePlayer && this.type === this.TYPES.game) {
			this.gamePlayer = new GamePlayer(this.playerInitConfig, this.video, this.option);
		} else if (window.ChannelPlayer && this.type === this.TYPES.channel) {
			this.channelPlayer = new ChannelPlayer();
			this.channelPlayer.setup(this.playerInitConfig);
		} else {
			window.nlRenderPlayer(this.playerInitConfig);
		}
	}

	_initPlayOptions(video, customConfig, option, type) {
		this._video = video;
		this.playerCustomConfig = customConfig;
		if (!this.i18n || (this.option['customLocaleText'] && option['customLocaleText'] && JSON.stringify(this.option['customLocaleText']) !== JSON.stringify(option['customLocaleText']))) {
			this.i18n = new I18N(this.locale, NeuPlayerStrings, this.name, option['customLocaleText']);
		}
		this.option = {...this.option, ...option};
		this.type = type;
	}

	/**
	 * Player config process
	 * ---------------------------------------------------------
	 */
	_initDefaultPlayerConfig() {
		this.playerDefaultConfig = {
			containerId: "nlPlayerContainer",
			server: this.SITE_CONFIG.LOC_SERVER,
			locResource: this.SITE_CONFIG.LOC_RESOURCE + "base/site/",
			locConfig: this.SITE_CONFIG.CDN_CONFIG,
			wmode: 'opaque',
			site: this.SITE_CONFIG.SITE_ID,
			nlHTML5: true,
			noFlash: true,
			useCustomControls: true,
			product: this.type,
			autostart: true,
			keepNonAsciiCharacters: false,
			sessionTimeoutCallback: () => this._playerSessionTimeoutCallback(), // Custom, not in nlplayer2
		};
		if (this.SITE_CONFIG.ANALYTICS_1 && this.SITE_CONFIG.ANALYTICS_1.indexOf("UA-") === 0) {
			this.playerDefaultConfig.gaa = this.SITE_CONFIG.ANALYTICS_1;
		}
		if (this.SITE_CONFIG.PERSONALIZATION_SERVER) {
			this.playerDefaultConfig.personalization = true;
		}
		if (this.SITE_CONFIG.PCM_SERVER) {
			this.playerDefaultConfig.concurrency = {
				pcm: {
					server: this.SITE_CONFIG.PCM_SERVER
				},
				callback: () => this._playerPCMConcurrencyCallback()
			};
		}
		if (this.SITE_CONFIG.LOC_QOS) {
			this.playerDefaultConfig.locQos = this.SITE_CONFIG.LOC_QOS;
			this.playerDefaultConfig.site = this.SITE_CONFIG.SITE_ID;
			if (this.CLIENT_CONFIG.user && this.CLIENT_CONFIG.user.username != null) {
				this.playerDefaultConfig.uid = this.CLIENT_CONFIG.user.username;
				this.playerDefaultConfig.userType = this.CLIENT_CONFIG.userType;
			}
		}
		if (this.CLIENT_CONFIG.user && this.CLIENT_CONFIG.user.trackUsername != null) {
			this.playerDefaultConfig.tuid = this.CLIENT_CONFIG.user.trackUsername;
		}
		if (navigator.userAgent.indexOf("Chrome") !== -1) {
			this.playerDefaultConfig.disablesv = "true";
		}
		if (this.CLIENT_CONFIG.locale != null && this.CLIENT_CONFIG.locale.length > 0) {
			this.playerDefaultConfig.locale = (this.CLIENT_CONFIG.user && this.CLIENT_CONFIG.user.locale) || this.CLIENT_CONFIG.locale || null;
		}
		if (!this.CLIENT_CONFIG.user || this.CLIENT_CONFIG.user.firstName === null || this.CLIENT_CONFIG.user.firstName === '') {
			this.playerDefaultConfig.nosp = true;
		}
		if (!!this.CLIENT_CONFIG.user && !!this.CLIENT_CONFIG.user.trackUserId) {
			this.playerDefaultConfig.tlid = this.CLIENT_CONFIG.user.trackUserId;
		}
		if (this.SITE_CONFIG.LICENSE_PROXY) {
			this.playerDefaultConfig.drm = {};
			let drmlps = this.SITE_CONFIG.LICENSE_PROXY.split(",");
			for (let i = 0; i < drmlps.length; i++) {
				let idx = drmlps[i].indexOf("=");
				this.playerDefaultConfig.drm[drmlps[i].substring(0, idx)] = drmlps[i].substring(idx + 1);
			}
		}
		if (this.PROJECT_CONFIG.enablePlayerAds !== undefined) {
			this.playerDefaultConfig.hasAds = this.PROJECT_CONFIG.enablePlayerAds;
		}
	}

	_postProcessPlayerConfig(config, video) {
		let playerConfig = {...config};
		if (playerConfig.hasAds === undefined && video && video.adTag) {
			playerConfig.hasAds = true;
		}
		if (playerConfig.sessionTimeoutCallback) {
			// nlplayer session poll timeout function, override nlplayer2's sessionTimeout
			window.sessionTimeout = playerConfig.sessionTimeoutCallback;
			delete playerConfig.sessionTimeoutCallback;
		}

		return playerConfig;
	}

	_initPlayerConfig() {
		this._initDefaultPlayerConfig();

		let mergedPlayerConfig = {...this.playerDefaultConfig, ...this.playerCustomConfig};

		this.playerInitConfig = this._postProcessPlayerConfig(mergedPlayerConfig, this.video);

		this._setPlayerCompleteCallback();

		// Custom channel callback
		let customCompleteCallback = this.playerInitConfig.completeCallback;
		this.playerInitConfig.completeCallback = () => {
			this._completeCallback();
			customCompleteCallback && customCompleteCallback();
		};
		let customLiveCompleteCallback = this.playerInitConfig.liveCompleteCallback;
		this.playerInitConfig.liveCompleteCallback = () => {
			this._liveCompleteCallback();
			customLiveCompleteCallback && customLiveCompleteCallback();
		};
		let customNLJumpToLiveProgramCallback = this.playerInitConfig.nlJumpToLiveProgramCallback;
		this.playerInitConfig.nlJumpToLiveProgramCallback = () => {
			this._nlJumpToLiveProgramCallback();
			customNLJumpToLiveProgramCallback && customNLJumpToLiveProgramCallback();
		};
		let customMarkersCallback = this.playerInitConfig.markersCallback;
		this.playerInitConfig.markersCallback = (data) => {
			this._playerVODMarkersCallback(data);
			customMarkersCallback && customMarkersCallback(data);
		};
		let customStatusCallback = this.playerInitConfig.statusCallback;
		this.playerInitConfig.statusCallback = (status) => {
			// status: loadedmetadata, paused, resume
			this._playerStatusCallback(status);
			customStatusCallback && customStatusCallback(status);
		};
		let customErrorCallback = this.playerInitConfig.errorCallback;
		this.playerInitConfig.errorCallback = (error) => {
			// error: AD_BLOCKER_DETECTED, GEO_BLOCKED, CONNECTION_ERROR, EMPTY_PUBLISHPOINT
			this._playerErrorCallback(error);
			customErrorCallback && customErrorCallback(error);
		};
		let customUnsupportedCallback = this.playerInitConfig.unsupportedCallback;
		this.playerInitConfig.unsupportedCallback = () => {
			this._playerUnsupportedCallback();
			customUnsupportedCallback && customUnsupportedCallback();
		};

		this._setPlayerReadyCallback(!!window.GamePlayer || !!window.ChannelPlayer);
	}

	_initPlayerEvents() {
		this.hasNEUEvent = !!window.NEU && !!window.NEU.event;

		this.on(this.eventType.PLAYER_READY, () => {
			if (!!this.playerInitConfig.hasAds) {
				this._overrideNLListenHTML5AdComplete();
			}
			if (!!this.PROJECT_CONFIG.enableContentLocalization) {
				this._overrideNLUpdateOverlay();
				this._overrideNLStartCasting();

				if (!!this.SITE_CONFIG.CHROMECAST_APP_ID) {
					this._overrideNLUpdateCastData();
					this._overrideQuadUpdateCastData();
				}
			}
			if (window.nlDRMPlayer) {
				this._drmPlayer = nlDRMPlayer;
				this._drmPlayer.addEventListener(AdaptivePlayer.EventType.PlayStart, (event) => {
					this.trigger(this.eventType.DRM_PLAYER_PLAY_START, event);
				});
				this._drmPlayer.addEventListener(AdaptivePlayer.EventType.ID3Event, (event) => {
					this.trigger(this.eventType.DRM_PLAYER_ID3EVENT, event);
				});
				this._drmPlayer.addEventListener(AdaptivePlayer.EventType.TimeUpdate, (event) => {
					this.trigger(this.eventType.DRM_PLAYER_TIME_UPDATE, event);
				});
			}

			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAYER_READY);
		});
		this.on(this.eventType.PLAYER_INIT_FAILED, (error) => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAYER_INIT_FAILED, error);
		});
		this.on(this.eventType.PLAYER_INITIALIZING, () => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAYER_INITIALIZING);
		});
		this.on(this.eventType.PLAYER_DESTROYED, () => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAYER_DESTROYED);
		});
		this.on(this.eventType.PLAYER_COMPLETED, (video = this.video) => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAYER_COMPLETED, video);
		});

		this.on(this.eventType.PLAY_START, (video) => {
			this.controllerConfig.isPlayStarted = this.controllerConfig.isPlayStarted || !!video;

			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAY_START, video);
		});

		this.on(this.eventType.PLAY_CHANGED, (video) => {
			let playOption = undefined;
			if (this.type === 'channel') {
				playOption = this._getGChannel();
			}
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAY_CHANGED, video, playOption);
		});

		// Deprecation: PLAY_CHANNEL_CHANGED, use PLAY_CHANGED instead
		this.on(this.eventType.PLAY_CHANNEL_LIVE_CONTINUE, (liveEPGItem) => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAY_CHANNEL_LIVE_CONTINUE, liveEPGItem);

			// Live continue is one case of play channel changed;
			this.trigger(this.eventType.PLAY_CHANNEL_CHANGED, liveEPGItem, this._getGChannel());
		});

		// Triggered from Non-neuPlayer
		this.on(this.eventType.PLAY_NEXT, () => {
			// Nothing
		});

		this.on(this.eventType.DRM_PLAYER_PLAY_START, (event) => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.DRM_PLAYER_PLAY_START, event);
		});
		this.on(this.eventType.DRM_PLAYER_TIME_UPDATE, (event) => {
			this.trigger(this.eventType.PLAYER_TIME_UPDATE, event.target.currentTime);
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.DRM_PLAYER_TIME_UPDATE, event);
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.PLAYER_TIME_UPDATE, event.target.currentTime);
		});
		this.on(this.eventType.DRM_PLAYER_ID3EVENT, (event) => {
			this.hasNEUEvent && window.NEU.event.trigger(this.eventType.DRM_PLAYER_ID3EVENT, event);

			let data = {...event.value.dict};
			if (data && (data.event === this.eventType.START_MARKER || data.event === this.eventType.END_MARKER)) {
				this.trigger(data.event, data);
				this.hasNEUEvent && window.NEU.event.trigger(data.event, data.object);
			}
		});

		if (this.hasNEUEvent) {
			this.stop = this.stop.bind(this);
			this.pause = this.pause.bind(this);
			this.resume = this.resume.bind(this);
			this.hide = this.hide.bind(this);
			this.seek = this.seek.bind(this);
			let triggerPlayNext = () => {
				this.trigger(this.eventType.PLAY_NEXT);
			};
			triggerPlayNext = triggerPlayNext.bind(this);

			window.NEU.event.on(this.eventType.STOP_PLAYER, this.stop)
					.on(this.eventType.PAUSE_PLAYER, this.pause)
					.on(this.eventType.RESUME_PLAYER, this.resume)
					.on(this.eventType.HIDE_PLAYER, this.hide)
					.on(this.eventType.SEEK_PLAYER, this.seek)
					.on(this.eventType.PLAY_NEXT, triggerPlayNext);

			// Deprecation: PLAY_CHANNEL_CHANGED
			this.on(this.eventType.PLAY_CHANNEL_CHANGED, (playingEPG, playingChannel) => {
				window.NEU.event.trigger(this.eventType.PLAY_CHANNEL_CHANGED, playingEPG, playingChannel);
			});
		}
	}

	_initPlugins() {
		for (let key in this._pluginClasses) {
			let option = this.option[key];
			if (option) {
				this.pluginsInstances[key] = new this._pluginClasses[key](this, option);
			}
		}
	}

	_destroyEvents() {
		if (this.hasNEUEvent) {
			window.NEU.event.off(this.eventType.STOP_PLAYER, this.stop)
					.off(this.eventType.PAUSE_PLAYER, this.pause)
					.off(this.eventType.RESUME_PLAYER, this.resume)
					.off(this.eventType.HIDE_PLAYER, this.hide)
					.off(this.eventType.SEEK_PLAYER, this.hide);
		}
	}

	/**
	 * Player config callback
	 * ---------------------------------------------------------
	 */
	_setPlayerReadyCallback(isCustom = false) {
		let callbackName = isCustom ? 'playerReadyCallback' : 'readyCallback',
				oldReadyCallback = this.playerInitConfig[callbackName],
				baseReadyCallback = this.playerInitConfig.readyCallback;
		this.playerInitConfig[callbackName] = () => {
			this.controllerConfig.isPlayerReady = true;
			window.nlReady = true;

			this.trigger(this.eventType.PLAYER_READY);

			oldReadyCallback && oldReadyCallback();

			// Call readyCallback only when custom player and if has readyCallback
			isCustom && baseReadyCallback && baseReadyCallback();

			this.playerInitConfig.autostart && this._playerPlay(true);
		};

		if (!this.playerInitConfig.autostart) {
			window.nlLastProgram = this.video;
		}
	}

	_setPlayerCompleteCallback() {
		let customCompleteCallback = this.playerInitConfig.completeCallback;
		this.playerInitConfig.completeCallback = () => {
			customCompleteCallback && customCompleteCallback(this.video);

			this.trigger(this.eventType.PLAYER_COMPLETED, this.video);
		};
	}

	_playerUnsupportedCallback() {
		if (this.controllerConfig.isHidden) {
			return null;
		}
		let unsupportedTipModalConfig = {
			desc: this._getKey("video_unsupported"),
			buttons: [
				{
					"title": this._getKey("ok"),
					"type": "yes",
				}
			]
		};
		NEU.ui.modal.show(unsupportedTipModalConfig);

		this.trigger(this.eventType.PLAYER_UNSUPPORTED);
		this.hasNEUEvent && NEU.event.trigger(this.eventType.PLAYER_UNSUPPORTED);
	}

	_playerErrorCallback(error) {
		this.trigger(this.eventType.PLAYER_OCCURRED_ERROR, error);
		this.hasNEUEvent && NEU.event.trigger(this.eventType.PLAYER_OCCURRED_ERROR, error);

		if (this.controllerConfig.isHidden) {
			return null;
		}
		switch (error.code) {
			case NLConstants.Error.CONNECTION_ERROR:
			{
				break;
			}
			case NLConstants.Error.EMPTY_PUBLISHPOINT:
			{
				break;
			}
			case NLConstants.Error.AD_BLOCKER_DETECTED:
			{
				this.controllerConfig.isInitFailed = true;
				this.controllerConfig.isAdBlockedModalShown = false;

				this.trigger(this.eventType.PLAYER_INIT_FAILED, error);

				this._showAdBlockedModal();
				break;
			}
			case NLConstants.Error.GEO_BLOCKED:
			{
				break;
			}
			default:
				break;
		}
	}

	_playerPCMConcurrencyCallback() {
		if (this.controllerConfig.isHidden) {
			return null;
		}
		let pcmModalConfig = {
			desc: this._getKey("video_session"),
			buttons: [
				{
					"title": this._getKey("continue"),
					"type": "yes",
					"callback": () => {
						// Workaround here to go with page reload, so if personalization service enabled, player will resume.
						parent.location.reload();
					}
				},
				{
					"title": this._getKey("cancel"),
					"type": "no"
				}
			]
		};
		NEU.ui.modal.show(pcmModalConfig);
	}

	// Default session timeout
	_playerSessionTimeoutCallback() {
		window.location.href = location.href;
	}

	_playerVODMarkersCallback(markers) {
		if (markers && Array.isArray(markers) && markers.length) {
			// Add markers
			if (this._drmPlayer && this._drmPlayer.currentTime !== undefined) {
				markers.forEach((marker) => {
					let time = null;
					if (this._drmPlayer.currentTime <= marker.start) {
						time = marker.start;
					} else if (this._drmPlayer.currentTime < marker.end) {
						time = this._drmPlayer.currentTime + 1;
					}
					if (time !== null) {
						this._drmPlayer.addCuepoints([
							{time: time, dict: {event: this.eventType.START_MARKER, object: marker}},
							{time: marker.end, dict: {event: this.eventType.END_MARKER, object: marker}},
						])
					}
				});
			}

			this.trigger(this.eventType.CALLBACK_MARKERS, markers);
			this.hasNEUEvent && NEU.event.trigger(this.eventType.CALLBACK_MARKERS, markers);
		} else {
			// Clear markers

		}
	}

	_playerStatusCallback(status) {
		this.trigger(this.eventType.PLAYER_STATUS_UPDATE, status);
		this.hasNEUEvent && NEU.event.trigger(this.eventType.PLAYER_STATUS_UPDATE, status);
	}

	/**
	 * Show Modal
	 * ---------------------------------------------------------
	 */
	_showAdBlockedModal() {
		if (!this.controllerConfig.isAdBlockedModalShown && !this.controllerConfig.isAdBlockedModalShownFixed) {
			// Show adBlocked modal;
			let adBlockedTipModalConfig = {
				desc: this._getKey("video_ad_blocked"),
				isCloseButton: false,
				buttons: [
					{
						"title": this._getKey("ok"),
						"type": "yes",
					}
				]
			};
			NEU.ui.modal.show(adBlockedTipModalConfig);

			this.controllerConfig.isAdBlockedModalShown = true;
			this.controllerConfig.isAdBlockedModalShownFixed = true;
		}
	}

	/**
	 * Player play
	 * ---------------------------------------------------------
	 */
	_playerPlay(isReadyCallback = false) {
		// For channel's only init case;
		if (this._video === undefined && isReadyCallback) {
			return;
		}

		if (!!this.PROJECT_CONFIG.enableParentalControls && !this._isPlayTrailer()) {
			this._playWithParentControl(this.video, this.option);
		} else {
			this._playerPlayWithPersonalData();
		}
	}

	_neuPlayerPlay() {
		let eventOption = undefined;
		if (this.type === this.TYPES.game && !!this.gamePlayer) {
			this.gamePlayer.playGame(this.video);
		} else if (this.type === this.TYPES.channel && !!this.channelPlayer) {
			this.channelPlayer.playChannel(this.video);
			eventOption = this._getGChannel(this.option);

			// Deprecation: PLAY_CHANNEL_CHANGED
			this.trigger(this.eventType.PLAY_CHANNEL_CHANGED, this._video, eventOption);
		} else {
			if (this.channelPlayer)
			{
				this.channelPlayer.playVOD(this.video);
			}
			else
			{
				window.nlPlayVideo(this.video);
			}
		}
		this.trigger(this.eventType.PLAY_CHANGED, this.video, eventOption);
	}

	_playerPlayWithPersonalData() {
		let playAfterCheckPersonal = () => {
			this._neuPlayerPlay();

			// Event: PLAY_START
			if (!this.playerInitConfig.hasAds || (!!this.video && (!this.video.adTag || window.nlAdPlayerObj === null)) || this._isPlayTrailer()) {
				this.trigger(this.eventType.PLAY_START, this.video);
			}
		};
		if (this._isNeedPlayWithPersonalData()) {
			let personalDataCallback = (personalData) => {
				this.video = {...this.video, ...personalData};

				if (this.type === this.TYPES.game) {
					this.video.offsetStart = this._getGameOffsetStart(this.video);
				}
				// Init player and play video
				playAfterCheckPersonal();
			};
			this._getPersonalData(this.video.id, this.type, personalDataCallback);
		} else {
			// Init player and play video
			playAfterCheckPersonal();
		}
	}

	/**
	 * Destroy nlplayer
	 * ---------------------------------------------------------
	 */
	_destroyNLPlayer() {
		// Destroy player dom
		let playerContainer = document.getElementById(this.playerInitConfig.containerId);
		if (!!playerContainer) {
			// Clean dom, container's class and style
			playerContainer.innerHTML = '';
			let playerContainerClasses = playerContainer.getAttribute('class').split(' ').filter(classItem => classItem.trim() !== '' && classItem.indexOf('playerMode') !== 0)
			playerContainer.setAttribute('class', playerContainerClasses.join(' '));
			playerContainer.setAttribute('style', '');

			let newPlayerContainer = playerContainer.cloneNode(true);
			playerContainer.parentNode.replaceChild(newPlayerContainer, playerContainer);

			this.trigger(this.eventType.PLAYER_DESTROYED);
		}

		// Clear timer
		window.clearTimeout(this.controllerConfig.tryPlayTimer);
		this.controllerConfig.tryPlayTimer = null;
		window.clearTimeout(this.controllerConfig.adBlockedTimer);
		this.controllerConfig.adBlockedTimer = null;

		// Reset isPlayerReady with undefined
		this.controllerConfig.isPlayerReady = undefined;
	}

	/**
	 * Get program status
	 * ---------------------------------------------------------
	 */
	_isPlayTrailer(video = this.video, option = this.option) {
		return !!video && video.trailer && option.playTrailer === true;
	}

	/**
	 * Personal data
	 * ---------------------------------------------------------
	 */
	_isNeedPlayWithPersonalData() {
		let isVideoNotNull = !!this.video;
		let isNotLiveVideo = isVideoNotNull && !this.video.isLive;
		let isWatchFromBeginning = isVideoNotNull && (this.video.watchbeginning || this._isPlayTrailer());
		return this.PROJECT_CONFIG.enablePs && isNotLiveVideo && !isWatchFromBeginning;
	}

	_getPersonalData(id, type, callback) {
		let urlParamOffset = NeuPlayer.getURLParam('offset'),
				isGameType = (/(game|coachfull|condensed)/gi.test(type));

		if (urlParamOffset !== false && !isGameType) {
			// Non-Game video: get offset from url param
			let personalData = {
				offsetStart: parseInt(urlParamOffset, 10)
			};
			callback(personalData);
		} else {
			let TIMEOUT = 3000,
					failed = false,
					personalType = isGameType ? 'game' : 'program',
					personalIds = isGameType ? id : (id + ',' + id + "_condensed"),
					timeoutHandler = () => {
						failed = true;
						callback({});
					},
					timeoutTimer = setTimeout(timeoutHandler, TIMEOUT),
					successCallback = (ret) => {
						if (!failed) {
							let personalData = {};
							if (!!ret && !!ret.contents) {
								let data = ret.contents;
								window.clearTimeout(timeoutTimer);
								timeoutTimer = null;

								if (data.length > 0) {
									if (isGameType) {
										personalData.history = {broadcast: {position: 0}, condensed: {position: 0}};

										for (let i = 0; i < data.length; i++) {
											if (data[i].watchHistory !== undefined) {
												if (data[i].id.indexOf("_") === -1) {
													personalData.history.broadcast.position = data[i].watchHistory.position;
												} else {
													personalData.history[data[i].id.split("_")[1]].position = data[i].watchHistory.position;
												}
											}
										}
									} else {
										for (let i = 0, l = data.length; i < l; i++) {
											if (data[i].id === id.toString() && data[i].watchHistory !== undefined) {
												personalData.offsetStart = data[i].watchHistory.position;
												break;
											}
										}
									}
								}
							}
							callback(personalData);
						}
					};
			if (!!this.option.personalContent) {
				let contents = Array.isArray(this.option.personalContent) ? this.option.personalContent : [this.option.personalContent];
				successCallback({contents: contents});
			} else {
				try {
					ps.personalContent.list(null, personalType, personalIds, successCallback);
				} catch (err) {
					successCallback();
				}
			}
		}
	}

	_getGameOffsetStart(game) {
		let offsetStart = game.offsetStart,
				gameHistory = game.history;
		if (!offsetStart && !!gameHistory) {
			switch (game.gs) {
				case this.GAME_STATE.ARCHIVE:
					if (game.gt === this.GAME_TYPE.BROADCAST && !!gameHistory.broadcast) {
						offsetStart = gameHistory.broadcast.position || 0;
					} else if (game.gt === this.GAME_TYPE.CONDENSED && !!gameHistory.condensed) {
						offsetStart = gameHistory.condensed.position || 0;
					}
					break;
				case this.GAME_STATE.LIVE:
					if (game.watchbeginning) {
						offsetStart = nlParseDateUTC(game.beginDateTimeGMT, true);
					}
					break;
				default:
					// Do nothing
					break;
			}
			offsetStart = offsetStart || 0;
		}
		return offsetStart;
	}

	/**
	 * Event type:
	 * ---------------------------------------------------------
	 */
	_overrideNLListenHTML5AdComplete() {
		// Add Ad completed event trigger
		let oldListenHTML5AdComplete = window.nlListenHTML5AdComplete;
		window.nlListenHTML5AdComplete = (info) => {
			oldListenHTML5AdComplete(info);

			// Event: play start
			this.trigger(this.eventType.PLAY_START, this.video);
		};
	}

	_overrideNLUpdateOverlay() {
		window.nlUpdateOverlay = () => {
			// Override Update overlay displayName
			let name = nlLastProgram.displayName !== undefined ? nlLastProgram.displayName : nlLastProgram.name,
					container = document.getElementById(nlConfigs.containerId);
			if (container.getElementsByClassName('nlOverlay')[0] != null) {
				container.getElementsByClassName('nlOverlayVideoTitle')[0].innerHTML = name;
				container.getElementsByClassName('nlOverlayVideoName')[0].innerHTML = name;

				if (nlLastProgram.image != null)
					container.getElementsByClassName('nlOverlayVideoThumbnail')[0].src = nlLastProgram.image;

				if (nlLastProgram.bigImage != null)
					container.getElementsByClassName('nlOverlay')[0].style.backgroundImage = "url(" + nlLastProgram.bigImage + ")";

				if (nlLastProgram.next != null) {
					let nextName = nlLastProgram.next.displayName !== undefined ? nlLastProgram.next.displayName : nlLastProgram.next.name;
					container.getElementsByClassName('nlOverlayNextVideoTitle')[0].innerHTML = nextName;
					container.getElementsByClassName('nlOverlayNextVideoThumbnail')[0].src = nlLastProgram.next.image;
				}
			}
		};
	}

	_overrideNLStartCasting() {
		window.nlStartCasting = () => {
			if (nlLastProgram != null) {
				let info = nlGetCastProgram(nlLastProgram);

				nlPauseVideo();
				nlIsCastingNow = true;

				let statusMsg = document.getElementsByClassName("nlCastStatus")[0];
				statusMsg.innerHTML = 'Casting ' + (info.displayName !== undefined ? info.displayName : info.name);
				nlShowCastOverlay();

				if (window.updateChromecastSession) {
					updateChromecastSession(true, info);
				}
			}
		};
	}

	_overrideNLUpdateCastData() {
		window.nlUpdateCastData = (p) => {
			p.displayName = window.nlLastProgram.displayName;
		};
	}

	_overrideQuadUpdateCastData() {
		if (!!window.QuadPlayer) {
			QuadPlayer.prototype.updateCastData = function (p) {
				p.displayName = this.lastProgram.displayName;
			}
		}
	}

	/**
	 * Hot fixed cases
	 * ---------------------------------------------------------
	 */
	_fixedAdBlockErrorNotWork() {
		// Fixed errorCallback not work when first init failed and try to init again;
		if (this.controllerConfig.isInitFailed) {
			this.controllerConfig.adBlockedTimer = window.setTimeout(() => {
				// Currently, just only ad block error case
				if (!this.controllerConfig.isAdBlockedModalShown) {
					this.trigger(this.eventType.PLAYER_INIT_FAILED, {code: NLConstants.Error.AD_BLOCKER_DETECTED});
					this._showAdBlockedModal();
					this.controllerConfig.isAdBlockedModalShownFixed = true;
				}
			}, this.controllerConfig.adBlockedTimeout);
		}
	}

	/**
	 * Process special: process functions
	 * ---------------------------------------------------------
	 */
	_processDRM(video) {
		let _video = {...video};
		if (_video.drm) {
			_video.isDRM = true;
			if (_video.publishPointParams != null) {
				_video.publishPointParams.deviceid = "web-" + this.CLIENT_CONFIG.sid;
			} else {
				_video.publishPointParams = {deviceid: "web-" + this.CLIENT_CONFIG.sid};
			}
		} else {
			_video.isDRM !== undefined && delete _video.isDRM;
		}
		return _video;
	}

	_processPCM(video, type) {
		let hasPCMServer = !!this.SITE_CONFIG.PCM_SERVER,
				isNotFreeGame = (type === this.TYPES.game && video.free !== 1 && video.free !== true),
				isNotFreeEvent = (type === this.TYPES.event && video.free !== 1 && video.free !== true),
				isNotFreeVideo = (type === this.TYPES.program && video.purchaseTypeId !== undefined && video.purchaseTypeId !== null),
				isNotFreeChannel = type === this.TYPES.channel; // For Linear Channel, currently no way to know if it is free and always have PCM process.
		if (hasPCMServer && (isNotFreeVideo || isNotFreeGame || isNotFreeEvent || isNotFreeChannel)) {
			let _video = {...video};
			if (_video.publishPointParams == null) {
				_video.publishPointParams = {};
			}
			_video.publishPointParams.pcid = this.CLIENT_CONFIG.sid;
			return _video;
		} else {
			return video;
		}
	}

	_processTrailer(video, option) {
		let hasAdTag = !!video && !!video.adTag;
		if (this._isPlayTrailer(video, option) && hasAdTag) {
			let _video = {...video};
			delete _video.adTag;
			return _video;
		} else {
			return video;
		}
	}

	/**
	 * Get locale content
	 * ---------------------------------------------------------
	 */
	_getKey(key, variable) {
		return this.i18n.get(key, variable);
	}

	/**
	 * Main process entry
	 * ---------------------------------------------------------
	 */

	_preProcessVideo(video, option) {
		let processedVideo = null;
		switch (this.type) {
			case 'program':
			case 'event':
				processedVideo = this._preProcessVideoProgram(video, option);
				break;
			case 'channel':
				processedVideo = this._preProcessVideoChannel(video, option);
				break;
			case 'game':
				processedVideo = this._preProcessVideoGame(video, option);
				break;
			default:
				console.warn(`Play with invalid type: ${this.type}`);
		}

		// Common process steps
		if (!!processedVideo) {
			processedVideo = this._processDRM(processedVideo);
			processedVideo = this._processPCM(processedVideo, this.type);
		}
		return processedVideo;
	}

	_postProcessVideo(video, option) {
		return this._processTrailer(video, option);
	}

	/**
	 * Custom overridden functions
	 * ---------------------------------------------------------
	 */

	_preProcessVideoProgram(video, option) {
		if (!video) {
			return video;
		}
		let _video = {...video};
		if (_video.liveState === 1) {
			_video.isLive = true;
		}
		if (_video.liveState === 2) {
			_video.isLive = true;
			_video.isDVRLive = true;
		}
		if (_video.trailer === true && option && option.playTrailer === true) {
			_video.publishPointParams = _video.publishPointParams || {};
			_video.publishPointParams.trailer = true;
		}
		if (!!this.PROJECT_CONFIG.enableContentLocalization) {
			_video.displayName = _video.name;
			_video.name = _video.seoName;
		}
		if (_video.image && _video.image.indexOf('http') !== 0) {
			_video.image = `${this.SITE_CONFIG.LOC_CONTENT}${_video.image}`;
		}
		if (_video.bigImage && _video.bigImage.indexOf('http') !== 0) {
			_video.bigImage = `${this.SITE_CONFIG.LOC_CONTENT}${_video.bigImage}`;
		}
		if (_video.next) {
			if (_video.next.image && _video.next.image.indexOf('http') !== 0) {
				_video.next.image = `${this.SITE_CONFIG.LOC_CONTENT}${_video.next.image}`;
			}
			if (_video.next.bigImage && _video.next.bigImage.indexOf('http') !== 0) {
				_video.next.bigImage = `${this.SITE_CONFIG.LOC_CONTENT}${_video.next.bigImage}`;
			}
		}

		return _video;
	}

	_preProcessVideoChannel(epgItem, option) {
		let _channel = this._getGChannel(option);
		if (!this.controllerConfig.isPlayStarted && NeuPlayer.getURLParam('watchbeginning') === 'true') {
			_channel.watchbeginning = true;
		}
		if (epgItem) {
			let isLive = option && option.isLive === true;
			if (option && option.customData) {
				_channel.customData = option.customData;
			}
			_channel.isLive = true;
			_channel.isDVRLive = !isLive;

			_channel = {..._channel, ...epgItem};

			if (isLive) {
				if ('endDateTimeGMT' in _channel) {
					delete _channel.endDateTimeGMT
				}
			} else {
				if ('nextDateTime' in _channel) {
					delete _channel.nextDateTime
				}
				if ('nextDateTimeGMT' in _channel) {
					delete _channel.nextDateTimeGMT
				}
			}
		}

		if (!!this.PROJECT_CONFIG.enableContentLocalization) {
			_channel.displayName = _channel.name;
			_channel.name = _channel.seoName.toUpperCase();
			_channel.epgShowName = `${_channel.seoName.toUpperCase()} - ${_channel.epgShowTime}`;
		}
		return _channel;
	}

	_preProcessVideoGame(game, option) {
		let _game = {...game};

		if (_game.gs === undefined) {
			_game.gs = _game.gameState;
		}
		_game.isLive = _game.gameState === 1 || _game.gameState === 2;
		_game.isDVRLive = _game.gameState === 2;
		_game.isGame = _game.isGame === 'true' || _game.isGame === true;
		_game.ended = _game.result != null || _game.endDateTimeGMT != null;
		if (_game.isGame) {
			_game.awayName = _game.awayTeam.name;
			_game.awayCode = _game.awayTeam.code;
			_game.homeName = _game.homeTeam.name;
			_game.homeCode = _game.homeTeam.code;

			// Chrome cast
			if (_game.awayLogo) {
				_game.awayTeam.logo = _game.awayLogo;
			}
			if (_game.homeLogo) {
				_game.homeTeam.logo = _game.homeLogo;
			}
		} else {
			// TODO: event
		}
		_game.blackout = !!_game.blackout;
		if (!!_game.dateTimeGMT && _game.beginDateTimeGMT === undefined) {
			_game.beginDateTimeGMT = _game.dateTimeGMT;
		}
		if (!!_game.et && _game.endDateTimeGMT === undefined) {
			_game.endDateTimeGMT = _game.et;
		}
		if (!_game.gt) {
			const DEFAULT_GAME_TYPE = 1; // BROADCAST
			let gts = _game.availablePrograms.toString(2).split('').reverse().map((i, index)=> i * Math.pow(2, index)).filter(i => i);
			_game.gt = (gts && gts.length && gts[0]) || option.defaultGameType || DEFAULT_GAME_TYPE;
		}

		if (!this.controllerConfig.isPlayStarted && NeuPlayer.getURLParam('watchbeginning') === 'true') {
			_game.watchbeginning = true;
			_game.offsetStart = nlParseDateUTC(_game.beginDateTimeGMT, true);
		}

		return _game;
	}

	/**
	 * Player config callback
	 * ---------------------------------------------------------
	 */
	_completeCallback() {
		if (this.type === this.TYPES.channel && window.epgList) {
			window.epgList.playNext(false, this.video.seoName);
		}
	}

	_liveCompleteCallback() {
		if (window.epgList || this.option.epgFeed) {
			let nextLiveEPG = null;
			if (window.epgList) {
				nextLiveEPG = window.epgList.getLiveEPGItem();
			} else if (this.option.epgFeed) {
				nextLiveEPG = this.option.epgFeed.config.channel.liveEPG;
			}
			let processedEPG = this._preProcessVideo(nextLiveEPG, {isLive: true});

			if (!!this.video.su && !!nextLiveEPG && !!nextLiveEPG.su && this.video.su !== nextLiveEPG.su) {
				this.channelPlayer.updateLastProgram(processedEPG);

				// Just update epgList playing status(will check hasLiveCompleteCallback = true to ignore playProgram in epgList.js);
				window.epgList && window.epgList.playNext(true, this.video.seoName);
				this._liveCompleteWithNewEPG(processedEPG);

				this.video = {...processedEPG};
			}
		} else {
			this.trigger(this.eventType.PLAY_CHANGED, this._getGChannel());

			// Deprecation: PLAY_CHANNEL_LIVE_CONTINUE
			this.trigger(this.eventType.PLAY_CHANNEL_LIVE_CONTINUE, this._getGChannel());
		}
	}

	_nlJumpToLiveProgramCallback() {
		if (window.epgList) {
			window.epgList.goLive(this.video.seoName);
		} else if (this.option.getLiveEPGItem) {
			let goLiveInChannel = (liveEPG) => {
				let processedEPG = this._preProcessVideo(liveEPG, {isLive: true});
				this.play(processedEPG, this.type, this.playerCustomConfig, this.option);
			};
			this.option.getLiveEPGItem(goLiveInChannel);
		}
	}

	/**
	 * Get global current channel object
	 * ---------------------------------------------------------
	 */

	_getGChannel(option) {
		let _channel = {};
		if (option && option.channel) {
			_channel = {...option.channel};
		} else if (window.epgList && window.epgList.getChannel) {
			_channel = {...window.epgList.getChannel()};
		} else if (window.epgLists && window.epgLists.getChannel) {
			_channel = {...window.epgLists.getChannel()};
		} else if (window.g_channel) {
			_channel = {...window.g_channel};
		} else {
			throw `Should have g_channel variable!`;
		}
		if (typeof (window.ENABLE_CHANNEL_DRM) !== 'undefined') {
			_channel.drm = !!window.ENABLE_CHANNEL_DRM;
		}
		return _channel;
	}

	/**
	 * Events
	 * ---------------------------------------------------------
	 */

	_liveCompleteWithNewEPG(liveEPGItem) {
		// Live completed with check parental controls
		if (!!this.PROJECT_CONFIG.enableParentalControls) {
			let successCallback = (video) => {
				this.trigger(this.eventType.PLAY_CHANGED, video);
				// Deprecation: PLAY_CHANNEL_LIVE_CONTINUE
				this.trigger(this.eventType.PLAY_CHANNEL_LIVE_CONTINUE, video);

				this.resume();
			};
			this._playWithParentControl(liveEPGItem, this.option, successCallback);
		} else {
			this.trigger(this.eventType.PLAY_CHANGED, liveEPGItem);
			// Deprecation: PLAY_CHANNEL_LIVE_CONTINUE
			this.trigger(this.eventType.PLAY_CHANNEL_LIVE_CONTINUE, liveEPGItem);
		}
	}

	/**
	 * Utils
	 * ---------------------------------------------------------
	 */
	static getURLParam(param) {
		let query = window.location.search.substring(1);
		let queryParams = query.split("&");
		for (let i = 0; i < queryParams.length; i++) {
			let queryParam = queryParams[i].split("=");
			if (queryParam.length > 1 && queryParam[0] === param) {
				return decodeURIComponent(queryParam[1]);
			}
		}
		return false;
	}

	/**
	 * Dependency config
	 * ---------------------------------------------------------
	 */
	static getSiteConfig() {
		let siteConfig = {};
		if (window.config) {
			siteConfig = window.config;
		} else {
			siteConfig = {
				LOC_SERVER: window.LOC_SERVER,
				LOC_RESOURCE: window.LOC_RESOURCE,
				LOC_CONTENT: window.LOC_CONTENT,
				CDN_CONFIG: window.CDN_CONFIG,
				ANALYTICS_1: window.ANALYTICS_1,
				LOC_QOS: window.LOC_QOS,
				LICENSE_PROXY: window.LICENSE_PROXY,
				PERSONALIZATION_SERVER: window.PERSONALIZATION_SERVER,
				PCM_SERVER: window.PCM_SERVER,
				SITE_ID: window.SITE_ID,
			};
		}
		return siteConfig;
	}

	static getProjectConfig() {
		let projectConfig = null;
		if (window.project) {
			projectConfig = window.project;
		} else {
			projectConfig = {
				enablePs: !!window.enablePs,
				enableContentLocalization: !!window.enableContentLocalization
			};
		}
		projectConfig.enablePs = projectConfig.enablePs && !!window.ps;
		return projectConfig;
	}

	static getClientConfig() {
		let clientConfig = null;
		if (window.client) {
			clientConfig = window.client;
		} else {
			clientConfig = {
				sid: window.sid,
				locale: window.locale,
				user: {
					username: window.username,
					firstName: window.firstname,
					locale: window.locale,
					trackUsername: window.trackUsername
				}
			};
		}
		return clientConfig;
	}
}

let neuPlayer = new NeuPlayer();

export default neuPlayer;

// Main API
// API - Init player
window.appInitPlayer = (config, type, option) => {
	return neuPlayer.play(undefined, config, option, type);
};
// API - 1. Player play program; 2. Init and play program;
window.appPlay = (video, type, config, option) => {
	return neuPlayer.play(video, config, option, type);
};

// Deprecated, don't use below, please use above API;
window.nlPlay = (video, type, config, option) => {
	console.warn('neuplayer.min.js: [Deprecation] nlPlay() is deprecated. Please use appPlay() instead.');
	return neuPlayer.play(video, type, config, option);
};